<template>
    <div ref="cameraGimbal"/>
</template>

<script>
  import nipplejs from "nipplejs";

  export default {
    name: "CameraGimbal",
    data() {
      return {
        x: 0,
        y: 0,
        firstX: 0,
        firstY: 0,
      }
    },
    mounted() {
        const percentageSize = 5;
        let screenSize = window.screen.width

        if (screenSize < window.screen.height) {
            screenSize = window.screen.height
        }

        const size = screenSize * percentageSize / 100;

        this.stick = nipplejs.create({
            zone: this.$refs.cameraGimbal,
            multitouch: true,
            mode: 'dynamic',
            size: size,
            color: 'blue'
        });

        this.stick.on('start', function() {
            this.$emit('onCameraGimbalStart');
        }.bind(this));

        this.stick.on('move', function(event, data) {
            this.x = data.raw.position.x;
            this.y = data.raw.position.y;
            this.firstX = data.instance.position.x;
            this.firstY = data.instance.position.y;
        }.bind(this));

        this.stick.on('end', function() {
            this.$emit('onCameraGimbalEnd');
        }.bind(this));
    }
  }
</script>

<style scoped>

</style>
